<template>
    <span :class="['search', {'top-header-search': topHeaderSearch }, size]">
        <input
            type="text"
            class="search__input"
            :placeholder="inputPlaceholder"
            v-bind="$attrs"
            v-bind:value="value"
            v-on:input="$emit('input', $event.target.value)"
        >
        <span class="search__tooltip" v-if="showTooltip">{{ $t("General.search_tooltip") }}</span>
        <span class="icon-search" @click="goToAllItemsList" v-if="!notEmptyValue"></span>
        <span class="icon-cancel" @click="clearSearch" v-if="notEmptyValue"></span>
    </span>
</template>

<script>
    export default {
        name: 'totem-search',
        data () {
            return {
                showTooltip: false
            }
        },
        props: {
            value: String,
            placeholder: String,
            topHeaderSearch: {
                type: Boolean,
                default: false
            },
            size: {
                type: String,
                validator: (prop) => ['small', 'medium'].includes(prop),
                default: 'medium'
            },
        },
        computed: {
            inputPlaceholder () {
                return this.placeholder ? this.placeholder : this.$t('General.search')
            },
            isLandingPage () {
                return (this.$route.name === 'home') || (this.$route.name === 'home-courses')
            },
            notEmptyValue () {
                return this.value !== null && this.value !== ''
            }
        },
        methods: {
            clearSearch () {
                this.$emit('clearSearch')
            },
            goToAllItemsList () {
                if (!this.isLandingPage) {
                    return false
                } else {
                    this.$router.push({ 'name': 'all-packages-all-content' })
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .search {
        position: relative;
        width: 100%;
        display: flex;

        [class*="desktop"] & {
            width: 285px;
        }

        &.top-header-search {
            margin: 0;

            [class*="desktop"] & {
                width: auto;
            }

            .search__input {
                border-radius: 30px;
                height: 42px;

                &::placeholder {
                    color: $emperor;
                }
            }
        }

        &__input {
            border: 1px solid $lavender;
            padding: 0 20px;
            width: 100%;
            border-radius: 10px;
            flex: 1;
            height: 48px;
            font-size: 1.6rem;

            &::placeholder {
                color: $emperor
            }
        }

        .icon-search,
        .icon-cancel {
            position: absolute;
            right: 20px;
            top: 50%;
            transform: translateY(-50%);
            color: $lavender;
        }

        &.small {
            .search__input {
                height: 33px;
                font-size: 1.2rem;
                padding: 0 16px;
            }
        }
    }
</style>
